// extracted by mini-css-extract-plugin
export var labelWrapper = "_fw-0";